"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M9.1 5C9.1 5.45869 8.87821 6.13108 8.42725 6.96425C7.99055 7.77108 7.39739 8.62426 6.7876 9.41411C6.1804 10.2006 5.57099 10.906 5.11226 11.4157C5.07372 11.4586 5.03627 11.5 5 11.5399C4.96373 11.5 4.92628 11.4586 4.88774 11.4157C4.42901 10.906 3.8196 10.2006 3.2124 9.41411C2.60261 8.62426 2.00945 7.77108 1.57275 6.96425C1.12179 6.13108 0.9 5.45869 0.9 5C0.9 2.73563 2.73563 0.9 5 0.9C7.26437 0.9 9.1 2.73563 9.1 5Z",
      stroke: "currentColor",
      strokeWidth: "1.8"
    })
  });
};

exports.default = Icon;